import React from "react";
import {MembershipCardPreview} from "./membership-card-designer";

export function CommunityCard({
                                  card_style, card_obj, goTo=()=>{}
                              }) {

    return <MembershipCardPreview {...card_obj} {...card_style} onClick={goTo} />
}